module.exports = __webpack_public_path__ + "static/media/Stephen A. Douglas - 1860.173eeeab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Stephen A. Douglas - 1860.jpg
// module id = 548
// module chunks = 0